"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViaSchema = void 0;
const zod_1 = require("zod");
const XYPosition_1 = require("./XYPosition");
exports.ViaSchema = zod_1.z.object({
    type: zod_1.z.literal('via'),
    center: XYPosition_1.XYPositionSchema,
    diameter: zod_1.z.number(),
    drillDiameter: zod_1.z.number(),
    layers: zod_1.z.number().array(),
    net: zod_1.z.string(),
    shape: zod_1.z.enum(['rect', 'circle', 'custom']),
    polygons: zod_1.z.number().array().array().array().optional(),
});
//# sourceMappingURL=Via.js.map